// Le graphique de la semaine — le regroupement PAR JOUR DU LECTEUR.
//
// 🔴 POURQUOI CE REGROUPEMENT EST CÔTÉ CLIENT, ET PAS EN SQL. `StockEntry` et
// `StockExit` ne portent AUCUNE date métier : leur seule date est `created_at`,
// un INSTANT. Or *un événement à 23:30 UTC le 11 août est déjà le 12 à
// Jérusalem*. Un `GROUP BY date(created_at)` côté serveur grouperait sur les
// jours **UTC** et donnerait un « lundi » faux à tout lecteur hors UTC.
// ⚠️ L'autre voie — le client envoie son décalage, le serveur groupe — a été
// écartée : elle réintroduirait un fuseau dans le serveur, ce que le lot T3 a
// passé un lot entier à en sortir (14 sites de `timeZone: 'Europe/Paris'`).
// **Le fuseau vient du navigateur, le serveur n'en parle pas.**
//
// 🔴 ET LA CONVERSION N'EST PAS RÉÉCRITE ICI. Ce module reçoit la fonction de
// jour (`formaterHorodatageEnJour`, liée à la langue par le hook) et s'en sert
// comme CLÉ de regroupement : deux instants du même jour local rendent la même
// chaîne, c'est tout ce dont un regroupement a besoin. *Une deuxième écriture
// de la conversion de fuseau serait la troisième forme du même défaut.*

/**
 * Construit l'axe des N derniers jours, du plus ancien au plus récent.
 * Chaque jour porte sa CLÉ (le jour local formaté) et son étiquette courte.
 *
 * ⚠️ L'AXE EST CONSTRUIT INDÉPENDAMMENT DES DONNÉES, et c'est le point : un
 * axe déduit des mouvements ferait DISPARAÎTRE les jours sans mouvement. Un
 * graphique qui saute les jours vides ment sur le rythme — trois entrées le
 * lundi et trois le vendredi ne se lisent pas comme deux jours consécutifs.
 */
export function axeDesJours(nbJours, maintenant, jourDe, etiquetteDe) {
  const jours = [];
  for (let i = nbJours - 1; i >= 0; i -= 1) {
    // ⚠️ ON RECULE EN MILLISECONDES depuis un instant, jamais en jouant sur
    // `setDate()` d'une date locale : les deux diffèrent au changement d'heure,
    // et c'est précisément un jour où l'on veut que le graphique reste juste.
    const instant = new Date(maintenant.getTime() - i * 24 * 60 * 60 * 1000);
    const iso = instant.toISOString();
    jours.push({ cle: jourDe(iso), etiquette: etiquetteDe(iso), entrees: 0, sorties: 0 });
  }
  return jours;
}

/**
 * Range les mouvements bruts dans l'axe. Rend `{jours, entrees, sorties,
 * etiquettes, horsAxe}`.
 *
 * ⚠️ `horsAxe` N'EST PAS UNE ERREUR, C'EST UNE MESURE. Un mouvement dont le
 * jour local ne tombe dans aucune case de l'axe existe légitimement — le
 * serveur filtre sur `created_at >= maintenant - 7 jours`, qui est une borne
 * en INSTANTS, alors que l'axe compte des JOURS locaux : aux deux extrémités,
 * les deux découpes ne coïncident pas exactement. Le compter permet de le
 * DIRE plutôt que de le perdre en silence.
 */
export function grouperParJour(mouvements, nbJours, maintenant, jourDe, etiquetteDe) {
  const jours = axeDesJours(nbJours, maintenant, jourDe, etiquetteDe);
  const parCle = new Map(jours.map((j) => [j.cle, j]));
  let horsAxe = 0;

  (mouvements || []).forEach((m) => {
    const jour = parCle.get(jourDe(m.horodatage));
    if (!jour) { horsAxe += 1; return; }
    const quantite = Number(m.quantite) || 0;
    if (m.sens === 'entree') jour.entrees += quantite;
    else jour.sorties += quantite;
  });

  return {
    jours,
    etiquettes: jours.map((j) => j.etiquette),
    entrees: jours.map((j) => j.entrees),
    sorties: jours.map((j) => j.sorties),
    horsAxe,
  };
}
